"use strict";
var Observable_1 = require('../../Observable');
var onErrorResumeNext_1 = require('../../operator/onErrorResumeNext');
Observable_1.Observable.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNextStatic;
//# sourceMappingURL=onErrorResumeNext.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/observable/onErrorResumeNext.js
 ** module id = 1154
 ** module chunks = 0
 **/